import { render, staticRenderFns } from "./FormBooks.vue?vue&type=template&id=501145ef&scoped=true&"
import script from "./FormBooks.vue?vue&type=script&lang=js&"
export * from "./FormBooks.vue?vue&type=script&lang=js&"
import style0 from "./FormBooks.vue?vue&type=style&index=0&id=501145ef&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501145ef",
  null
  
)

export default component.exports